<div class="open-task-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" *ngIf="tasks != null && tasks.length > 0">
            <mat-label>
                {{'has open task of type' |
                translate:['tmc-yard.widgets.filter-administration.details-editor.transport.open-task-editor.has-open-task-of-type',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="taskTypeExternalKey" name="taskTypeExternalKey">
                <mat-option *ngFor="let task of tasks" [value]="task.externalKey">
                    {{task.nameDictionaryKey | translate: [task.nameDictionaryKey, translationService.language]}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>